module.exports = __webpack_public_path__ + "static/hongxing-0de7982ea1a0168c7b0afad5d94e206b.png";